<template>
  <div class="q-pa-md border-radius-top q-pt-md-none">
    <div class="bg-white q-pa-md q-mt-sm q-mb-md rounded">
      <div class="col-12">
        <div class="bg-white q-mx-md-md">
          <div class="header" style="text-align: center; padding-top: 100px; padding-bottom: 100px">
            <QSpinner color="primary" size="10em" />
          </div>
          <div class="q-px-lg q-py-sm">
            <MainHeadline
              align="center"
              header="Thank you for completing the application."
              body="Please wait while we submit your application, <br/>this will only take a few seconds."
            />
          </div>
          <br />
          <br />
          <MoreInfoBlock />
          <br />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { QSpinner } from 'quasar';
import { mapGetters } from 'vuex';
import { GLOBAL_ERROR } from '@/components/GlobalError/GlobalError';
import MainHeadline from '@/components/Atoms/MainHeadline';
import MoreInfoBlock from '@/components/Atoms/MoreInfoBlock';
import QueryCreditCheck from '@/graphql/queries/QueryCreditCheck';
import MyCustomFunctions from '@/mixins/MyCustomFunctions.js';
import { applicationTypeForCalculatorApis } from '@/utils/calculator/scoreboardApplicationType';

export default {
  name: 'CalculatorApplicationWaiting',
  mixins: [MyCustomFunctions],
  data: function () {
    return {
      timer: '',
      times: 0,
      results: [],
      queryVariable: null
    };
  },
  components: { MainHeadline, QSpinner, MoreInfoBlock },
  apollo: {
    creditCheck: {
      query: QueryCreditCheck,
      debounce: 300,
      fetchPolicy: 'network-only',
      variables() {
        return {
          param: this.queryVariable,
          applicationType: applicationTypeForCalculatorApis(this.vehicleApplication)
        };
      },
      skip() {
        return !this.queryVariable;
      },
      result: function (res) {
        if (res && res.data && res.data.creditCheck && res.data.creditCheck.result)
          this.results.push(res.data.creditCheck.result.toLowerCase());
      },
      error: function () {
        this.$euiNotifications.emit({
          notification: GLOBAL_ERROR,
          action: () => {
            return this.$apollo.queries.creditCheck.refresh();
          }
        });
      }
    }
  },
  computed: {
    ...mapGetters({
      vehicleApplication: 'vehicleApplication/vehicleApplication'
    }),
    creditCheckInternalId() {
      if (this.vehicleApplication) return this.vehicleApplication.applicationId.substring(0, 8) + '3';
      else return null;
    }
  },
  created() {
    this.fetchEventsList();
    this.timer = setInterval(this.fetchEventsList, 10000);
  },
  methods: {
    async fetchEventsList() {
      this.queryVariable = null;
      setTimeout(() => {
        this.queryVariable = this.creditCheckInternalId;
      });
      this.times++;

      if (this.times >= 3) {
        this.cancelAutoUpdate();

        if (this.results.length) {
          if (this.results.includes('approved')) await this.updateVehicleApplication('approved', 'statusCreditCheck');

          this.$router.push({ name: 'reviewAndSignContract' });
        } else this.$router.push({ name: 'logout' });
      }
    },
    cancelAutoUpdate() {
      clearInterval(this.timer);
    }
  },
  beforeDestroy() {
    this.cancelAutoUpdate();
  }
};
</script>
